export default function convertObjectToSnakeCase(data: Record<string, any> = {}): Record<string, any> {
  const snakeCasedData = { ...data };
  Object.keys(snakeCasedData).forEach((key) =>
    typeof snakeCasedData[key] === 'string'
      ? (snakeCasedData[key] = snakeCasedData[key].toLowerCase().split(' ').join('_'))
      : snakeCasedData[key]
  );

  return snakeCasedData;
}
